<template>
  <div class="nothing-here" data-test-id="nothing-here">
    <div class="nothing-here__shrug">¯\_(ツ)_/¯</div>
    <div class="nothing-here__info">{{ $t('nothingHere.info') }}</div>
  </div>
</template>

<style lang="scss">
.nothing-here {
  flex: 1 0 auto;
  font-size: 18px;
  line-height: 28px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.nothing-here__shrug {
  font-weight: 500;
  padding-bottom: 8px;
}
</style>
